<div [ngClass]="{'col-12 col-xl-6' : !allSettings}">
  <div class="card">
    <div class="card-header">
      <div class="float-end fit-content h-100 d-flex flex-column align-items-end mt-2 gap-2">
      </div>
      <h5 class="card-title">Calendario</h5>
      <h6 class="card-subtitle text-muted">Parámetros de configuración del Calendario</h6>
    </div>

    <div class="card-body">
      <form>




        <div class="form-group row">
          <label class="col-form-label col-sm-4 text-sm-right">Formato de hora</label>
          <div class="col-sm-8">
            <select class="form-select" name="mode1224" [(ngModel)]="cfgData.mode1224"
              (change)="changesMade=_deviceService.checkChangesSettings(originalData,cfgData)">
              <option [ngValue]=0>24 horas</option>
              <option [ngValue]=1>12 horas</option>
            </select>
          </div>
        </div>


        <div class="form-group row">
          <label class="col-form-label col-sm-4 text-sm-right">Corrección de orto</label>
          <div class="col-sm-8">
              <input class="form-control" type="time" id="sunrise" [(ngModel)]="sunrise" name="sunrise"
               (change)="changesMade=_deviceService.checkChangesSettings(originalData,cfgData)">
          </div>
        </div>

        <div class="form-group row">
          <label class="col-form-label col-sm-4 text-sm-right">Corrección de ocaso</label>
          <div class="col-sm-8">
              <input class="form-control" type="time" id="sunset" [(ngModel)]="sunset" name="sunset"
               (change)="changesMade=_deviceService.checkChangesSettings(originalData,cfgData)">
          </div>
        </div>





        <div class="form-group row">
          <div class="col-sm-10 ms-sm-auto">
            <button type="submit" class="btn btn-primary" (click)="save()" [disabled]="!changesMade">{{"overwrite" |
              translate}}</button>
            <button type="submit" class="btn btn-light ms-2" [disabled]="!changesMade">{{"restore"
              | translate}}</button>
          </div>
        </div>

        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="error!=''">
          <div class="alert-message">
            {{ error }}
          </div>
        </div>
        <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
          <div class="alert-message">
            {{"updatedSuccesfully" | translate}}
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
